import { commonTranslationKeys } from '@dreryk/react-common';
import { Modal, ModalCancelButton, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { historicalLeavesTranslationKeys } from '../../../../../translations';
import { printMedicalLeaveZla } from '../../historicalLeaves.utils';

import { ForeignInsuredPrintForm } from './ForeignInsuredPrintForm';

const modalTranslationKeys = historicalLeavesTranslationKeys.foreignInsuredPrintModal;

type ForeignInsuredPrintModalProps = {
   readonly copyId: number;
   readonly originalId: number;
   readonly onClose: VoidFunction;
};

export const ForeignInsuredPrintModal = (props: ForeignInsuredPrintModalProps): JSX.Element => {
   return (
      <Modal testId={'foreignInsuredPrintModal'} title={modalTranslationKeys.title} width={ModalWidth.NORMAL}>
         <ForeignInsuredPrintForm>
            {({ handleSubmit }) => (
               <>
                  <ModalConfirmButton
                     label={historicalLeavesTranslationKeys.print}
                     onClick={handleSubmit(async (values) => {
                        const documentId = values.printType === 'ORIGINAL' ? props.originalId : props.copyId;
                        await printMedicalLeaveZla(documentId);
                        props.onClose();
                     })}
                  />
                  <ModalCancelButton label={commonTranslationKeys.cancel} onClick={props.onClose} />
                  <ModalCloseButton onClick={props.onClose} />
               </>
            )}
         </ForeignInsuredPrintForm>
      </Modal>
   );
};
